import { all, takeLatest } from 'lib/redux';
import { LOAD_ADDRESS_VERIFICATION_PAGE } from 'constants/ActionTypes';
import loadAddressVerificationSaga from './AddressVerification.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_ADDRESS_VERIFICATION_PAGE, loadAddressVerificationSaga),
  ]);
}
